import type { ComponentProps } from 'react';
import { PlusIcon } from 'lucide-react';

import { cn } from '@/lib/utils';

import './document-add-cta-button.scss';

type DocumentAddCtaButtonProps = {
  label: string;
  onClick: () => void;
} & Omit<ComponentProps<'button'>, 'onClick' | 'children' | 'type'>;

function DocumentAddCtaButton({
  label,
  onClick,
  className,
  ...props
}: DocumentAddCtaButtonProps) {
  return (
    <button
      type="button"
      className={cn('document-add-cta-button', className)}
      onClick={onClick}
      {...props}
    >
      <span className="document-add-cta-button__label">{label}</span>
      <PlusIcon
        size={14}
        className="document-add-cta-button__icon"
        aria-hidden
      />
    </button>
  );
}

export { DocumentAddCtaButton };
